import React from 'react';
import { useHistory } from 'react-router-dom';
import { CancelButton } from '../../components/buttons/CancelButton.component';
import { ConfirmButton } from '../../components/buttons/ConfirmButton.component';
import { Paths } from '../../utils/routerUrls';
import { useStyles } from './SelectEnvironment.styles';
import { useTranslation } from 'react-i18next';

export const ConfirmSelection: React.FC = () => {
  const styles = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className={styles.confirmation}>
      <h1 className={styles.header}>{`Wybierz kontekst pracy w ${t('global:shortNames.system')}`}</h1>
      <CancelButton
        style={{ width: '180px' }}
        onClick={() => {
          sessionStorage.setItem('context', 'admin');
          history.push(Paths.adminDashboard);
        }}
      >
        {t('context:buttons.admin')}
      </CancelButton>
      <ConfirmButton
        style={{ width: '180px' }}
        onClick={() => {
          sessionStorage.setItem('context', 'examiner');
          history.push(Paths.dashboard);
        }}
      >
        {t('context:buttons.examiner')}
      </ConfirmButton>
    </div>
  );
};
